import React, { Component } from 'react';
import { connect } from 'react-redux';
import compact from 'lodash/compact';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Select from 'react-select';
import { isInt } from 'validator';
import { Link } from 'react-router-dom';
import {
  Form,
  FormGroup,
  Input,
  Label,
  Button,
  FormText,
  InputGroup,
  InputGroupAddon,
  Col,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { object, func, array } from 'prop-types';
import ProfileAvatar from '../../../../components/Profile/ProfileAvatar';
import TimezoneSelector from '../../../../components/Profile/TimezoneSelector';
import CustomControl from '../../../../components/CustomControl/CustomControl';
import { defaultLocale, defaultLanguages, defaultTheme } from '../../../../config';
import SocialsList from '../../../../components/Socials/SocialsList';

class ProfileEditForm extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    submit: func.isRequired,
    profile: object.isRequired,
    updateProfile: func.isRequired,
    onSavingPhone: func.isRequired,
    themes: array.isRequired,
    languages: array.isRequired,
  };

  static defaultProps = {
    profile: {},
    languages: defaultLanguages,
  };

  constructor(props) {
    super(props);

    const { profile } = props;

    const { visibleAccountFields, visibleAccountInputs } = this.getVisibleAccountFields(
      profile.accounts,
    );

    this.state = {
      upload: false,
      data: {
        img: profile.img ? profile.img : '',
        login: profile.login ? profile.login : '',
        email: profile.email ? profile.email : '',
        phone: profile.phone ? profile.phone : '',
        skype: profile.skype ? profile.skype : '',
        icq: profile.icq ? profile.icq : '',
        not_use_in_stats: profile.not_use_in_stats ? profile.not_use_in_stats : false,
        phone_approved: profile.phone_approved ? profile.phone_approved : false,
        timezone: profile.timezone ? profile.timezone : '',
        language: profile.language ? profile.language : defaultLocale,
        // theme: profile.theme ? profile.theme : defaultTheme,
        theme: defaultTheme,
        use_transit_service: profile.use_transit_service ? profile.use_transit_service : false,
        accounts: profile.accounts ? profile.accounts : [],
      },
      validation: {
        login: 'isRequired',
        icq: 'isInt',
      },
      errors: {},
      isEmailReadOnly: !!profile.email,
      dropdownOpen: false,
      visibleAccountFields,
      visibleAccountInputs,
      visibleAccountFieldIdFocus: null,
    };

    this.$fileInput = React.createRef();
    this.$currentAccountRef = React.createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { profile } = nextProps;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        ...profile,
      },
      isEmailReadOnly: !!profile.email,
    }));
  }

  componentDidUpdate(prevProps, { visibleAccountFieldIdFocus }) {
    const { visibleAccountFieldIdFocus: NEXTvisibleAccountFieldIdFocus } = this.state;
    if (visibleAccountFieldIdFocus !== NEXTvisibleAccountFieldIdFocus) {
      if (this.$currentAccountRef) {
        this.$currentAccountRef.focus();
      }
    }
  }

  getVisibleAccountFields = (accounts = []) => {
    const visibleAccountFields = [];
    const visibleAccountInputs = [];
    accounts.forEach((account) => {
      if (account) {
        if (!account.login) {
          visibleAccountFields.push(account.id);
        } else {
          visibleAccountInputs.push(account.id);
        }
      }
    });
    return {
      visibleAccountFields,
      visibleAccountInputs,
    };
  };

  validate = (fields) => {
    const errors = {};
    const { intl } = this.props;
    const { data, validation } = this.state;

    Object.keys(fields).forEach((field) => {
      switch (validation[field]) {
        case 'isRequired':
          data[field].length === 0 &&
            (errors[field] = intl.formatMessage({
              id: 'profile.error.required',
              defaultMessage: 'This field is required',
            }));
          break;

        case 'isInt':
          !isInt(data[field]) &&
            data[field].length > 0 &&
            (errors[field] = intl.formatMessage({
              id: 'profile.error.number',
              defaultMessage: 'This field must be a number',
            }));
          break;

        default:
          break;
      }
    });

    if (Object.keys(errors).length > 0) {
      return errors;
    }

    return false;
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  onChange = (e) => {
    const { target } = e;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [target.name]: target.value,
      },
    }));
  };

  onSelectChange = (prop, value) => {
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [prop]: value,
      },
    }));
  };

  onChangeTimezone = (timezone) => {
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        timezone,
      },
    }));
  };

  onChangeChecked = ({ target }) => {
    const { name } = target;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [name]: !prevState.data[name],
      },
    }));
  };

  onSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate(this.state.validation);
    this.setState(() => ({ errors }));

    if (Object.keys(errors).length === 0) {
      this.props.submit(this.prepareData(this.state.data));
    }
  };

  prepareData = (data) => {
    const { accounts, ...rest } = data;
    const preparedData = { ...rest };
    accounts.forEach((account) => {
      preparedData[`accounts[${account.id}]`] = account.login;
    });
    return preparedData;
  };

  handleSavePhone = () => {
    const { phone } = this.state.data;
    const { intl } = this.props;

    if (phone.length === 0) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          phone: intl.formatMessage({
            id: 'profile.error.required',
            defaultMessage: 'This field is required',
          }),
        },
      }));
    } else if (phone.length < 10) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          phone: intl.formatMessage({
            id: 'profile.error.invalid-number',
            defaultMessage: 'Invalid number. Try to enter number with country code.',
          }),
        },
      }));
    } else {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          phone: '',
        },
      }));
      this.props.onSavingPhone(phone);
    }
  };

  handleFileUpload = () => {
    this.props.updateProfile({ isAvatarUpdate: true });
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  onAccountChange = (e) => {
    const { target } = e;

    this.setState((prevState) => {
      const fieldsIndex = prevState.data.accounts.findIndex(({ title }) => title === target.name);
      const newAccounts = [...prevState.data.accounts];
      if (fieldsIndex >= 0) {
        newAccounts[fieldsIndex] = {
          ...newAccounts[fieldsIndex],
          login: target.value,
        };
      }
      return {
        data: {
          ...prevState.data,
          accounts: newAccounts,
        },
      };
    });
  };

  handleAdditionalContactClick = (id) => {
    this.setState((prevState) => ({
      visibleAccountFields: compact(
        prevState.visibleAccountFields.filter((fieldId) => fieldId !== id),
      ),
      visibleAccountInputs: compact([...prevState.visibleAccountInputs, id]),
      visibleAccountFieldIdFocus: id,
    }));
  };

  render() {
    const {
      img,
      login,
      email,
      phone,
      skype,
      not_use_in_stats,
      phone_approved,
      timezone,
      language,
      theme,
      use_transit_service,
    } = this.state.data;

    const {
      errors,
      isEmailReadOnly,
      dropdownOpen,
      data,
      visibleAccountFields,
      visibleAccountInputs,
    } = this.state;
    const { languages, themes, timezones, socials, accounts, handleUnsubscribe } = this.props;

    return (
      <Form onSubmit={this.onSubmit} autoComplete="off" className="profile-edit-form">
        {/* <ProfileAvatar avatar={img} error={errors.img} onFileUpload={this.handleFileUpload} /> */}
        <Row>
          <Col xs="12" lg="6">
            <FormGroup row className="mx-0 with-formtext">
              <Label htmlFor="email">
                <FormattedMessage id="profile.email" defaultMessage="E-mail" />
              </Label>
              <Col xs="8" sm="9">
                <Input
                  id="email"
                  type="email"
                  name="email"
                  value={email}
                  readOnly={isEmailReadOnly}
                  onChange={(e) => (isEmailReadOnly ? false : this.onChange(e))}
                />
                {isEmailReadOnly && (
                  <FormText color="muted">
                    <FormattedMessage
                      id="profile.change_possible"
                      defaultMessage="Change is possible only on request to the"
                    />{' '}
                    <Link to="/tickets/create">
                      <FormattedMessage id="profile.support" defaultMessage="support" />
                    </Link>
                  </FormText>
                )}
              </Col>
            </FormGroup>

            <FormGroup row className={errors.login ? 'has-error mx-0' : 'mx-0'}>
              <Label htmlFor="name">
                <FormattedMessage id="profile.name" defaultMessage="Name" />
              </Label>
              <Col xs="8" sm="9">
                <Input id="name" type="text" name="login" value={login} onChange={this.onChange} />
                {errors.login && <small className="form-text">{errors.login}</small>}
              </Col>
            </FormGroup>

            <FormGroup
              row
              className={errors.phone ? 'has-error mx-0 with-formtext' : 'mx-0 with-formtext'}
            >
              <Label htmlFor="phone">
                <FormattedMessage id="profile.phone.theme_4" defaultMessage="Phone" />
              </Label>
              <Col xs="8" sm="9">
                {phone_approved ? (
                  <Input id="phone" type="tel" name="phone" value={phone} readOnly />
                ) : (
                  <InputGroup>
                    <Input
                      id="phone"
                      type="tel"
                      name="phone"
                      placeholder="XXXXXXXXX"
                      value={phone}
                      onChange={this.onChange}
                      autoComplete="tel"
                    />
                    <InputGroupAddon addonType="append">
                      <Button
                        type="button"
                        color="primary"
                        onClick={this.handleSavePhone}
                        className={errors.phone ? 'has-error' : ''}
                      >
                        <FormattedMessage id="main.save" defaultMessage="Save" />
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                )}

                {errors.phone && <small className="form-text">{errors.phone}</small>}

                {phone_approved && (
                  <FormText color="muted">
                    <FormattedMessage
                      id="profile.change_possible"
                      defaultMessage="Change is possible only on request to the"
                    />{' '}
                    <Link to="/tickets/create">
                      <FormattedMessage id="profile.support" defaultMessage="support" />
                    </Link>
                  </FormText>
                )}
              </Col>
            </FormGroup>

            <FormGroup row className="mx-0 with-formtext">
              <Label htmlFor="skype">
                <FormattedMessage id="profile.skype" defaultMessage="Skype" />
              </Label>
              <Col xs="8" sm="9">
                <Input id="skype" type="text" name="skype" value={skype} onChange={this.onChange} />
                {errors.skype && <small className="form-text">{errors.skype}</small>}
              </Col>
            </FormGroup>

            <TimezoneSelector
              theme={4}
              timezones={timezones}
              selected={timezone}
              error={errors.timezone}
              onChangeTimezone={this.onChangeTimezone}
            />

            <FormGroup row className="mx-0">
              <Label htmlFor="language">
                <FormattedMessage id="profile.language" defaultMessage="Language" />
              </Label>
              <Col xs="8" sm="9">
                <Select
                  className="Select--sm"
                  id="language"
                  name="language"
                  clearable={false}
                  value={language}
                  onChange={({ value }) => this.onSelectChange('language', value)}
                  options={languages.map((lang) => ({
                    value: lang.key,
                    label: lang.title,
                  }))}
                />
              </Col>
            </FormGroup>

            {themes.length > 1 && (
              <FormGroup row className="mx-0">
                <Label htmlFor="theme">
                  <FormattedMessage id="main.theme" defaultMessage="Type" />
                </Label>
                <Col xs="8" sm="9">
                  <Select
                    className="Select--sm"
                    id="theme"
                    name="theme"
                    clearable={false}
                    value={theme}
                    onChange={({ value }) => this.onSelectChange('theme', value)}
                    options={themes.map((themeObj) => ({
                      value: themeObj.id,
                      label: themeObj.name,
                    }))}
                  />
                </Col>
              </FormGroup>
            )}

            {/* {visibleAccountInputs.length > 0 &&
              visibleAccountInputs.map(id => {
                const field = data.accounts.find(item => item.id === id);
                if (field) {
                  return (
                    <FormGroup key={`profile-field-${field.id}`}>
                      <Label htmlFor={field.title}>{field.title}</Label>
                      <Input
                        innerRef={input => (this.$currentAccountRef = input)}
                        id={field.title}
                        type="text"
                        name={field.title}
                        value={field.login === null ? '' : field.login}
                        onChange={this.onAccountChange}
                      />
                    </FormGroup>
                  );
                }
              })} */}
          </Col>
          <Col xs="12" lg="6" className="right-col">
            {data.accounts.map(({ id, login, title }) => {
              return (
                <FormGroup row className="mx-0" key={`profile-field-${id}`}>
                  <Label htmlFor={title}>{title}</Label>
                  <Col xs="8" sm="9">
                    <Input
                      innerRef={(input) => (this.$currentAccountRef = input)}
                      id={title}
                      type="text"
                      name={title}
                      value={login === null ? '' : login}
                      onChange={this.onAccountChange}
                    />
                  </Col>
                </FormGroup>
              );
            })}

            <FormGroup>
              <SocialsList
                socials={socials}
                accounts={accounts}
                onUnsubscribe={handleUnsubscribe}
              />
            </FormGroup>

            {/* {visibleAccountFields.length ? (
              <FormGroup>
                <Dropdown
                  isOpen={dropdownOpen}
                  toggle={this.toggleDropdown}
                  direction="down"
                  className="profile-additions"
                >
                  <DropdownToggle caret color="primary" outline>
                    <FormattedMessage id="profile.additional.button" defaultMessage="Add contact" />
                  </DropdownToggle>
                  <DropdownMenu flip={false}>
                    {visibleAccountFields.map(id => {
                      const field = data.accounts.find(item => item.id === id);
                      if (field) {
                        return (
                          <DropdownItem
                            key={`profile-button-${field.id}`}
                            onClick={() => this.handleAdditionalContactClick(field.id)}
                          >
                            {field.title}
                          </DropdownItem>
                        );
                      }
                    })}
                  </DropdownMenu>
                </Dropdown>
              </FormGroup>
            ) : null} */}
          </Col>
          <Col xs="12" className="bottom-col">
            <FormGroup>
              <ul className="profile-extra-settings list-unstyled no-margin">
                <li>
                  <CustomControl
                    id="not_use_in_stats"
                    name="not_use_in_stats"
                    className="custom-control-xs"
                    onChange={this.onChangeChecked}
                    checked={not_use_in_stats}
                    value="1"
                  >
                    <FormattedMessage
                      id="profile.dont_use_statistics"
                      defaultMessage="Do not use my data in statistics"
                    />
                  </CustomControl>
                </li>
              </ul>
            </FormGroup>
            <FormGroup row className="mx-0">
              <ul className="profile-extra-settings list-unstyled no-margin">
                <li>
                  <CustomControl
                    id="use_transit_service"
                    name="use_transit_service"
                    className="custom-control-xs"
                    onChange={this.onChangeChecked}
                    checked={use_transit_service}
                    value="1"
                  >
                    <FormattedMessage
                      id="profile.use_transit_service"
                      defaultMessage="Enable service «1001transits for affiliates»"
                    />
                  </CustomControl>
                </li>
              </ul>
            </FormGroup>

            <Button size="sm" color="primary mt-3">
              <FormattedMessage id="main.save" defaultMessage="Save" />
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = ({ app }) => ({
  languages: app.globalSettings.languages,
  themes: app.globalSettings.themes,
});

export default connect(mapStateToProps)(injectIntl(ProfileEditForm));
